
import { defineComponent, ref } from 'vue'

export default defineComponent({
  inheritAttrs: false,
  setup() {
    const visiblePassword = ref(false)
    return {
      visiblePassword,
    }
  },
})
